import React, { useState, useEffect } from "react"
import Input from "../../Components/Input"
import InputNumeric from "../../Components/InputNumeric"
import Select from "../../Components/Select"
import Titulo from "../../Components/Titulo"
import SearchCity from "../City/Search"
import image_clean from "../../Images/Buttons/clean.png"
import image_save from "../../Images/Buttons/save.png"
import image_previous from "../../Images/Buttons/previous.png"
import image_search from "../../Images/Buttons/search.png"

const ServiceMunicipal = ({databaseType, databasePath, jsonCompany, jsonLogin, system, jsonServiceMunicipal, save, returnAdd, showMenu, 
  width}) => {

  const [originCode, setOriginCode] = useState("")
  const [code, setCode] = useState("")  
  const [serviceNationalCode, setServiceNationalCode] = useState("")
  const [cityCode, setCityCode] = useState("")
  const [cityName, setCityName] = useState("")
  const [description, setDescription] = useState("")
  const [aliquotFederal, setAliquotFederal] = useState(0)
  const [aliquotState, setAliquotState] = useState(0)
  const [aliquotMunicipal, setAliquotMunicipal] = useState(0)
  const [standard, setStandard] = useState(2)

  const [showCity, setShowCity] = useState(false)

  useEffect(() => { 
    if (jsonServiceMunicipal.CODE !== undefined){
      setOriginCode(jsonServiceMunicipal.CODE)
      setCode(jsonServiceMunicipal.CODE)
      document.getElementById("serviceMunicipalDescription") && document.getElementById("serviceMunicipalDescription").focus()      
    } else document.getElementById("serviceMunicipalCode") && document.getElementById("serviceMunicipalCode").focus()

    setServiceNationalCode(jsonServiceMunicipal.SERVICE_CODE_NATIONAL.CODE)

    if (jsonServiceMunicipal.CITY !== undefined){
      if (jsonServiceMunicipal.CITY.ID !== undefined) setCityCode(jsonServiceMunicipal.CITY.ID)
      if (jsonServiceMunicipal.CITY.NAME !== undefined) setCityName(jsonServiceMunicipal.CITY.NAME)
    }

    setDescription(jsonServiceMunicipal.DESCRIPTION)

    if ((jsonServiceMunicipal.ALIQUOT_FEDERAL !== null) && (jsonServiceMunicipal.ALIQUOT_FEDERAL !== undefined))
    setAliquotFederal(formatNumeric(jsonServiceMunicipal.ALIQUOT_FEDERAL,2))

    if ((jsonServiceMunicipal.ALIQUOT_STATE !== null) && (jsonServiceMunicipal.ALIQUOT_STATE !== undefined))
    setAliquotState(formatNumeric(jsonServiceMunicipal.ALIQUOT_STATE,2))

    if ((jsonServiceMunicipal.ALIQUOT_MUNICIPAL !== null) && (jsonServiceMunicipal.ALIQUOT_MUNICIPAL !== undefined))
    setAliquotMunicipal(formatNumeric(jsonServiceMunicipal.ALIQUOT_MUNICIPAL,2))
    
    if (jsonServiceMunicipal.DEFAULT !== undefined) setStandard(parseInt(jsonServiceMunicipal.DEFAULT))
    else setStandard(2)

  }, [jsonServiceMunicipal])

  const cleanCity = () => {
    setCityCode("")
    setCityName("")
  }  

  const enableCity = () => {
    setShowCity(!showCity)
  }

  const fillCity = (state) => {
    setCityCode(state.ID)
    setCityName(state.NAME)
    setShowCity(false)
  }

  const formatNumeric = (value, decimals) => {
    if (!value) return "0.00"
    if (value === ".") return value = "0."
      
    const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimals}})?`)

    let decimalsNumber = 0
    try { decimalsNumber = value.toString().match(regex)[0] } catch { decimalsNumber = 0 }

    const parsed = parseFloat(decimalsNumber).toFixed(decimals)

    if (isNaN(parsed)) return "0.00"
    return parsed
  }

  const handleAliquotFederal = (event) => {
    setAliquotFederal(formatNumeric(event.target.value, 2))
  }

  const handleAliquotState = (event) => {
    setAliquotState(formatNumeric(event.target.value, 2))
  }

  const handleAliquotMunicipal = (event) => {
    setAliquotMunicipal(formatNumeric(event.target.value, 2))
  }

  const onSave = () => {
    var json = "{"
    if (originCode === "") json += " \"TYPE\": 1"; else json += " \"TYPE\": 2"

    json += ", \"CODE\": \""+ code + "\""
    json += ", \"SERVICE_CODE_NATIONAL\": { \"CODE\": \"" + serviceNationalCode + "\" }"
    json += ", \"DESCRIPTION\": \""+ description +"\""
    json += ", \"CITY\": { \"ID\": "+ cityCode +", \"DESCRIPTION\": \""+ cityName +"\" }"
    json += ", \"ALIQUOT_FEDERAL\": "+ aliquotFederal
    json += ", \"ALIQUOT_STATE\": "+ aliquotState
    json += ", \"ALIQUOT_MUNICIPAL\": "+ aliquotMunicipal
    json += ", \"DEFAULT\": \""+ standard + "\""
    json += " }"

    save(json)
  }

  const setFieldSelected = () => {
  }  

  return(
    <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
      { !showCity ?
          <>
            <div div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center"}}>
              <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10, marginLeft: 5,
                width: 147}} onClick={() => onSave()}>
                <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, paddingRight: 10, 
                  paddingBottom: 5, paddingLeft: 10}}>
                  <img style={{height: 32, width: 32}} src={image_save} alt="Salvar"/>
                </div>
                <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                  <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
                </div>
              </div>

              <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, marginTop: 10, marginLeft: 5,
                width: 147}} onClick={() => returnAdd()}>
                <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, paddingRight: 10, 
                  paddingBottom: 5, paddingLeft: 10}}>
                  <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                </div>
                <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                  <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                </div>
              </div>
            </div>

            <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 10}}>
              <div style={{backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10, width: "98%"}} />
            </div>

            { originCode === "" ? <b>Inclusão:</b> : <b>Alteração:</b>  }

            <div style={(showMenu) ?
                (width < 1290) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
              :
                (width < 990) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
              <div style={(showMenu) ? 
                  (width < 640) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                  : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 1}
                  : (width < 990) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                  : {display: "flex", flexDirection: "row", flexGrow: 1}
                :
                  (width < 640) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                  : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                <div style={(showMenu) ?
                    (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180}
                    : (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 240, maxWidth: 240}
                    : (width < 990) ? {display: "flex", flexGrow: 1, minWidth: 180}
                    : {display: "flex", flexGrow: 0, minWidth: 240, maxWidth: 240}
                  :
                    (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180}
                    : {display: "flex", flexGrow: 0, minWidth: 240, maxWidth: 240}}>

                  <Input
                    type="text"
                    name="serviceMunicipalCode"
                    description="Código"
                    value={code || ""}
                    maxLength={3}
                    disabled={(originCode === "") ? false : true}
                    require={false}
                    image={false}
                    typeInput={2}
                    onSelect={setFieldSelected}
                    onChange={(event) => setCode(event.target.value)} />
                </div>
                <div style={(showMenu) ? 
                    (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                    : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                    : (width < 990) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                    : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                  : 
                    (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                    : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}}>

                  <Input
                    type="text"
                    name="serviceMunicipalDescription"
                    description="Descrição"
                    value={description}
                    disabled={false}
                    require={false}
                    image={false}
                    typeInput={2}
                    onSelect={setFieldSelected}
                    onChange={(event) => setDescription(event.target.value)} />
                </div>
              </div>
              <div style={(showMenu) ?
                  (width < 1280) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                  : {display: "flex", flexGrow: 0, minWidth: 180, marginLeft: 10}
                :
                  (width < 990) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                  : {display: "flex", flexGrow: 0, minWidth: 180, marginLeft: 10}}>
                <Select
                  name="serviceMunicipalStandard"
                  description="Padrão"
                  value={standard || 2}
                  require={false}
                  options={JSON.parse("{ \"RESULT\": [{\"ID\": 0, \"VALUE\": \"Selecione...\" }, {\"ID\": 1, \"VALUE\": \"Sim\" }"+
                  ", {\"ID\": 2, \"VALUE\": \"Não\" }] }")}
                  image={true}
                  typeInput={2}
                  onSelect={setFieldSelected}
                  set={setStandard} />
              </div>
            </div>

            <div style={(showMenu) ?
                (width < 1230) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}
              :
                (width < 950) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 10}
                : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>

              <div style={(showMenu) ?
                  (width < 710) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                  : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}
                :
                  (width < 390) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                  : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 10}}>

                <div style={(showMenu) ?
                    (width < 710) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                    : {display: "flex", flexGrow: 1, flexBasis: 1}
                  :
                    (width < 390) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                    : {display: "flex", flexGrow: 1, flexBasis: 1}}>

                  <InputNumeric
                    type="text"
                    name="serviceMunicipalAliquotFederal"
                    description="Alíquota Federal(%)"
                    value={aliquotFederal || ""}
                    maxLength={13}
                    disabled={false}
                    require={true}
                    negative={false} 
                    image={false}
                    typeInput={2}
                    onSelect={setFieldSelected}
                    onChange={handleAliquotFederal} />
                </div>

                <div style={(showMenu) ?
                    (width < 710) ? {display: "flex", flexGrow: 1, marginTop: 10}
                    : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10}
                  :
                    (width < 390) ? {display: "flex", flexGrow: 1, marginTop: 10}
                    : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10}}>

                  <InputNumeric
                    type="text"
                    name="serviceMunicipalAliquotState"
                    description="Alíquota Estadual(%)"
                    value={aliquotState || ""}
                    maxLength={13}
                    disabled={false}
                    require={true}
                    negative={false} 
                    image={false}
                    typeInput={2}
                    onSelect={setFieldSelected}
                    onChange={handleAliquotState} />
                </div>
              </div>

              <div style={(showMenu) ?
                  (width < 1230) ? {display: "flex", flexGrow: 1, marginTop: 10}
                  : {display: "flex", flexGrow: 1, flexBasis: 1, marginTop: 10, marginLeft: 10}
                :
                  (width < 950) ? {display: "flex", flexGrow: 1, marginTop: 10}
                  : {display: "flex", flexGrow: 1, flexBasis: 1, marginTop: 10, marginLeft: 10}}>

                <InputNumeric
                  type="text"
                  name="serviceMunicipalAliquotMunicipal"
                  description="Alíquota Municipal(%)"
                  value={aliquotMunicipal || ""}
                  maxLength={13}
                  disabled={false}
                  require={true}
                  negative={false} 
                  image={false}
                  typeInput={2}
                  onSelect={setFieldSelected}
                  onChange={handleAliquotMunicipal} />
              </div>
            </div>

            <div style={{marginTop: 10, minWidth: 180, width: "100%"}}>
              <Titulo description="Cidade" />
            </div>

            <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, minWidth: 180}
              : {display: "flex", flexGrow: 0, paddingLeft: 10, paddingRight: 10, minWidth: 180}}>

              <div style={{display: "flex", flexGrow: 1}}>
                <Input
                  type="search"
                  name="serviceMunicipalCityName"
                  description="Nome"
                  planceHolder=""
                  value={cityName}
                  maxLength={60}
                  disabled={true}
                  require={true}
                  image={false}
                  typeImage={0}
                  typeInput={2}
                  onSelect={setFieldSelected}
                  onChange={(event) => setCityName(event.target.value)} />
              </div>
              <div style={(width < 450) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 10}
                : {display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}}>

                <img
                  style={{height: 42, width: 42}}
                  name="ServiceMunicipalSearchCity"
                  src={image_search} 
                  alt="Pesquisar" 
                  onClick={enableCity} />

                  <img
                    style={{marginLeft: 10, height: 42, width: 42}}
                    name="ServiceMunicipalCleanCity"
                    src={image_clean} 
                    alt="Limpar"
                    onClick={cleanCity} />
              </div>
            </div>
          </>
        :
          <div style={{marginTop: 10}}>
            <div style={{marginLeft: 10}}>
              <b>Selecione a Cidade:</b>
            </div>

            <SearchCity
              modeSearch={true}
              databaseType={databaseType}
              databasePath={databasePath}
              jsonCompany={jsonCompany}
              jsonLogin={jsonLogin}
              system={system}
              setAdd={() => alert("")}
              setSelected={fillCity} 
              setReturn={() => setShowCity(false)} 
              showMenu={showMenu}
              width={width} />
          </div>
      }

    </div>
  )
}

export default ServiceMunicipal